import { useGetLocalizationText } from "_store/localization/selectors";
import Popup from "components/Popup/Popup";
import React from "react";
import "./StopPopup.css";

export default function StopPopup({ onClose }) {
  const getLocalizationText = useGetLocalizationText();

  return (
    <Popup
      className="stop-popup-container"
      style={{
        display: "flex",
        flexDirection: "column",
        borderRadius: "0px",
        alignItems: "self-start",
        justifyContent: "start",
        padding: "10px",
        background: "var(--primarySuperLightGray)",
        overflow: "auto",
        overflowX: "hidden",
        maxHeight: "90%",
      }}
      onClose={onClose}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "50px",
        }}
      >
        <div style={{ marginBottom: "25px", fontSize: "24px", fontWeight: "400", lineHeight: "30px", letterSpacing: "0em", textAlign: "center" }}>
          {getLocalizationText("Step0_RegionDisabled_Title")}
        </div>
        <div style={{ marginBottom: "40px", fontSize: "15px", fontWeight: "300", lineHeight: "30px", letterSpacing: "0.03em", textAlign: "center", width: "75%" }}>
          {getLocalizationText("Step0_RegionDisabled_Text")}
        </div>
      </div>
    </Popup>
  );
}
